import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Users, Building, BuildingCommunity, Settings } from 'tabler-icons-react';
import isEmpty from 'lodash.isempty';

import { getUserRoles } from '../../redux/auth/selectors';

import { userRoles } from '../../constants/userRoles';

export const useMenuItems = () => {
  const { t } = useTranslation();
  const roles = useSelector(getUserRoles);

  const menuItems = {
    myCompanies: {
      key: 'myCompanies',
      label: <Link to='/front/my-companies'>{t('menu.myCompanies')}</Link>,
      icon: <BuildingCommunity size={16} />,
    },
    companies: {
      key: 'companies',
      label: <Link to='/front/companies'>{t('menu.companies')}</Link>,
      icon: <Building size={16} />,
    },
    users: {
      key: 'users',
      label: <Link to='/front/users'>{t('menu.users')}</Link>,
      icon: <Users size={16} />,
    },
    settings: {
      key: 'settings',
      label: <Link to='/front/settings'>{t('menu.settings')}</Link>,
      icon: <Settings size={16} />,
    },
  };

  return isEmpty(roles) || !Array.isArray(roles)
    ? []
    : roles.includes(userRoles.ADMIN)
    ? [menuItems.myCompanies, menuItems.companies, menuItems.users, menuItems.settings]
    : roles.includes(userRoles.SUPER_USER)
    ? [menuItems.myCompanies, menuItems.companies]
    : roles.includes(userRoles.MODERATOR)
    ? [menuItems.myCompanies, menuItems.companies]
    : roles.includes(userRoles.OPERATOR)
    ? [menuItems.myCompanies]
    : [];
};
